import { call, put } from 'redux-saga/effects';

import { apiGeneral, notify } from 'services';
import { ICreateRequest } from 'interfaces/create-duck';
import { requestErrorHandler } from 'utils';
import { CreateCarrierAreaContactActions } from 'store/ducks/settings/carrier-area-contact';

export function* createCarrierAreaContactRequest(action: any) {
  try {
    const { postData, onSuccess } = action as ICreateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.post,
      `/carrier/contacts`,
      postData
    );

    const { data } = responseBody;
    yield put(CreateCarrierAreaContactActions.success(data));
    notify('success', 'Contato cadastrada com sucesso');
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(CreateCarrierAreaContactActions.failure(errorMessage));
  }
}
